<template>
  <div>
    <div class="intro-y flex flex-row justify-between mt-4 sm:mt-8">
      <div class="flex flex-row items-end mb-2 md:mb-0">
        <div
          class="px-2 mr-2 sm:px-8 py-2 lg:text-2xl font-bold text-yellow-400 border-yellow-400 border text-center rounded-md"
        >
          Employee Master
        </div>
      </div>
      <div
        cclass="flex flex-col sm:flex-row gap-2 grid-cols-1 text-rigth"
        class="md:w-1/2 grid grid-cols-1 text-right"
      >
        <div class="">
          <button
            class="btn btn-warning disabled:opacity-50"
            @click="sync"
            :disabled="spinnerBtn"
          >
            <DownloadCloudIcon class="w-4 h-4 mr-2" v-if="!spinnerBtn" />
            <LoadingIcon
              icon="oval"
              color="white"
              v-else
              class="w-4 h-4 mr-2"
            />
            Sync
          </button>
        </div>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5 table-report table-report--tabulator"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, onBeforeUnmount } from 'vue'
// import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
// import { filterOption } from './index'
import { myHeaders, api } from '@/utils/api'
import { helper } from '@/utils/helper'
// import store from '../../../store'
import { useStore } from '@/store'

// import router from '@/router'
import alert from '../../helpers/alert'
import feather from 'feather-icons'
import { ajaxURLGenerator } from '../../helpers'

export default defineComponent({
  setup() {
    const store = useStore()
    const tableRef = ref()
    const tabulator = ref()

    const spinnerBtn = ref(false)
    const sync = async () => {
      spinnerBtn.value = true
      await api
        .get('/hr/employee/sync')
        .then(res => {
          if (res.code == 200) {
            // console.log('res: ', res)
            alert.success(res.data.employee)
          } else {
            alert.error(res.message)
          }
          spinnerBtn.value = false
        })
        .catch(e => {
          alert.error(e.message)
          spinnerBtn.value = false
        })
    }

    const filter = reactive({
      field: 'bu_no',
      type: 'like',
      value: ''
    })

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL:
          process.env.VUE_APP_API_URL +
          '/admin/employee/all?fields=employee_id,username,fullname_th,fullname_en,comp_code,position',
        ajaxLoader: true,
        ajaxFiltering: true,
        ajaxSorting: true,
        virtualDom: false,
        pagination: 'remote',
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 100,
        paginationSizeSelector: [100, 200, 300, 400],
        ajaxConfig: {
          method: 'GET',
          headers: await myHeaders()
        },
        ajaxResponse: async (url, params, response) => {
          // console.log('res datatable: ', response.data.data)

          if (response.code == 200) {
            return response.data
          } else {
            await store.commit('notification/toast', {
              type: 'danger',
              message: 'message',
              description: 'desc'
            })
            await store.commit('notification/toastShow', {})
            return false
          }
        },
        ajaxURLGenerator: ajaxURLGenerator,
        columns: [
          {
            title: 'No',
            field: 'employee_id',
            headerFilter: true,
            width: '10%'
          },
          {
            title: 'Image',
            field: 'employee_image',
            width: '10%',
            formatter: cell => {
              return `<div class="intro-x w-10 h-10 image-fit text-theme-9 "><img class="rounded-full img-employee" src="${
                cell.getData().employee_image
              }"/></div>`
            }
          },
          {
            title: 'User Name',
            field: 'username',
            width: '10%'
          },
          {
            title: 'ชื่อ',
            field: 'fullname_th',
            headerFilter: true,
            width: '20%'
          },
          {
            title: 'Name',
            field: 'fullname_en',
            headerFilter: true,
            width: '20%'
          },
          {
            title: 'Company',
            field: 'comp_code',
            width: '10%'
          },
          {
            title: 'Position',
            field: 'position',
            headerFilter: true,
            width: '20%'
          }
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
          cash('.img-employee').on('error', helper.imgError)
        }
      })
    }

    // const filterOption = ref([])
    onMounted(async () => {
      initTabulator()
    })

    onBeforeUnmount(() => {
      if (tabulator.value) {
        tabulator.value.destroy()
      }
    })

    return {
      tableRef,
      filter,
      spinnerBtn,
      sync
    }
  }
})
</script>
